'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var UgSewerStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('on the way to the shop', Q('specialist_notified', 'specialist_notification_skipped'))
	.add('preparing to work', Q('geo:at_shop', 'geo:at_shop_skipped'))
	.add('on-scene', Q('geo:arrived'))
	.add('work completed', Q('geo:departed', 'geo:location_skipped'))
	.add('team done', Q('team:done'))
	.add('awaiting approval', Q('form_skipped'))
;


export default function(incident) {
	UgSewerStateDiagram.updateIncident(incident);
	incident.phoneFromUrl = reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	incident.problemTypes = [
		{
			code: 'SWR 001',
			display: 'Internal custom request',
			options: [
				'New Lateral Install',
				'Air Relief Valve',
				'Force Main',
				'Lateral Repair',
				'Manhole Repair',
				'Gravity Main',
				'Pump Station',
				'Sewer Plug',
			],
		},
		{
			code: 'SWR 002',
			display: 'External customer request',
			options: [
				'City Right of Way',
				'Clean Out',
				'Manhole',
				'Pipe Concern',
				'Issue in Home or Business',
				'Pump Station',
			],
		},
	];
}
